// extracted by mini-css-extract-plugin
export var button = "TrainingTimes-module--button--36ccc";
export var header = "TrainingTimes-module--header--0643f";
export var home = "TrainingTimes-module--home--88ec6";